import { Routes } from '@angular/router';
import { HomePageComponent } from './features/home/home-page.component';
import { PromotionsPageComponent } from './features/promotions/promotions-page.component';

export const routes: Routes = [
  { path: '', component: HomePageComponent, title: 'Hexacorp I.T. Solutions — Cloud, Payments & Custom Software' },
  { path: 'promotions', component: PromotionsPageComponent, title: 'Promotions & Referrals — Hexacorp I.T. Solutions' },
  { path: '**', redirectTo: '' },
];
